var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5C6.95869 11.5 8.35764 10.9205 9.38909 9.88909C10.4205 8.85764 11 7.45869 11 6C11 4.54131 10.4205 3.14236 9.38909 2.11091C8.35764 1.07946 6.95869 0.5 5.5 0.5C4.04131 0.5 2.64236 1.07946 1.61091 2.11091C0.579463 3.14236 0 4.54131 0 6C0 7.45869 0.579463 8.85764 1.61091 9.88909C2.64236 10.9205 4.04131 11.5 5.5 11.5ZM6.13938 5.02925L5.45187 8.26394C5.40375 8.49769 5.47181 8.63037 5.66088 8.63037C5.79425 8.63037 5.99569 8.58225 6.1325 8.46125L6.072 8.74725C5.87469 8.98513 5.4395 9.15837 5.06481 9.15837C4.5815 9.15837 4.37594 8.86825 4.50931 8.25156L5.01669 5.86731C5.06069 5.66587 5.02081 5.593 4.81938 5.54419L4.50931 5.4885L4.56569 5.22656L6.14006 5.02925H6.13938ZM5.5 4.28125C5.31766 4.28125 5.1428 4.20882 5.01386 4.07989C4.88493 3.95095 4.8125 3.77609 4.8125 3.59375C4.8125 3.41141 4.88493 3.23655 5.01386 3.10761C5.1428 2.97868 5.31766 2.90625 5.5 2.90625C5.68234 2.90625 5.8572 2.97868 5.98614 3.10761C6.11507 3.23655 6.1875 3.41141 6.1875 3.59375C6.1875 3.77609 6.11507 3.95095 5.98614 4.07989C5.8572 4.20882 5.68234 4.28125 5.5 4.28125Z",
    fill: "#9277FF",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.89fab37696777ac2a088e65bb72f2eaf.svg";
export { ForwardRef as ReactComponent };